import logoShopify from "../_assets/img/registration/logo-shopify.svg";
import logoAmazon from "../_assets/img/registration/logo-amazon.png";
import logoWooCommerce from "../_assets/img/registration/logo-woocommerce.svg";
import logoEbay from "../_assets/img/registration/logo-ebay.svg";
import logoTikTok from "../_assets/img/registration/logo-tiktok.svg";
import logoKaufland from "../_assets/img/registration/logo-kaufland.png";
import logoOtto from "../_assets/img/registration/logo-otto.png";
import logoZalando from "../_assets/img/registration/logo-zalando.png";
import logoAboutYou from "../_assets/img/registration/logo-aboutyou.png";
import logoStripe from "../_assets/img/registration/logo-stripe.svg";
import logoChargebee from "../_assets/img/registration/logo-chargebee.png";
import logoDatev from "../_assets/img/datev-cloud-logo.svg";
import { IntegrationIcon } from "./Integration";

// Central brand mark per integration (#42360: "brand logos are sourced
// centrally, not embedded per component").
//
// Two sources, both already in the repo: the registration flow's imported assets
// and a handful of SVGs served from public/. Imported assets are content-hashed
// by webpack; the public/ ones are plain URLs.
const PUBLIC_LOGO = {
    adyen: "/adyen-logo.svg",
    gocardless: "/gocardless-logo.svg",
    klarna: "/klarna-logo.svg",
    mollie: "/mollie-logo.svg",
    unzer: "/unzer-logo.png",
};

// The square variant of a mark, where the brand publishes one. A wide wordmark shrunk into a 16px rail slot is
// unreadable, so the rail asks for this first and falls back to the wide mark.
const SQUARE_LOGO = {
    UNZER: "/unzer-icon.png",
};

// Keyed by brand family, not by identifier: a marketplace and its payment
// counterpart (KAUFLAND / KAUFLAND_PAYMENTS) share one mark.
const BRAND_LOGOS = {
    SHOPIFY: logoShopify,
    AMAZON: logoAmazon,
    WOO_COMMERCE: logoWooCommerce,
    EBAY: logoEbay,
    TIKTOK: logoTikTok,
    KAUFLAND: logoKaufland,
    OTTO: logoOtto,
    ZALANDO: logoZalando,
    ABOUT_YOU: logoAboutYou,
    STRIPE: logoStripe,
    CHARGEBEE: logoChargebee,
    ADYEN: PUBLIC_LOGO.adyen,
    GOCARDLESS: PUBLIC_LOGO.gocardless,
    KLARNA: PUBLIC_LOGO.klarna,
    MOLLIE: PUBLIC_LOGO.mollie,
    UNZER: PUBLIC_LOGO.unzer,
    // Without this DATEV fell through to the fa-plug fallback — a cable and plug where the brand's own mark
    // was already sitting in the repo.
    DATEV: logoDatev,
};

// Longest prefix first, so ABOUT_YOU is not shadowed and TIKTOK_SHOP resolves
// to the TikTok mark.
const FAMILY_ORDER = [
    "ABOUT_YOU",
    "UNZER",
    "DATEV",
    "WOO_COMMERCE",
    "GOCARDLESS",
    "CHARGEBEE",
    "KAUFLAND",
    "SHOPIFY",
    "ZALANDO",
    "TIKTOK",
    "AMAZON",
    "STRIPE",
    "KLARNA",
    "MOLLIE",
    "ADYEN",
    "OTTO",
    "EBAY",
];

/**
 * Brand mark for an integration identifier, or null when none exists.
 * Callers should fall back to getIntegrationIcon for a Font Awesome glyph.
 */
export const getIntegrationLogo = (integration) => {
    const key = (integration || "").toUpperCase();
    const family = FAMILY_ORDER.find((candidate) => key.includes(candidate));

    return family ? BRAND_LOGOS[family] : null;
};

/** The square mark where the brand has one, otherwise the wide mark. For small square slots such as the rail. */
export const getIntegrationSquareLogo = (integration) => {
    const key = (integration || "").toUpperCase();
    const family = FAMILY_ORDER.find((candidate) => key.includes(candidate));

    return (family && SQUARE_LOGO[family]) || getIntegrationLogo(integration);
};

/** Font Awesome class for an integration, used where no brand mark exists. */
export const getIntegrationIcon = (integration) => IntegrationIcon[integration] || "fa fa-plug";

/** True when the integration has a real brand mark rather than a glyph. */
export const hasIntegrationLogo = (integration) => !!getIntegrationLogo(integration);
